/* Product Slider Call */

$(document).ready(function() {
	/* $("#productViewer").lightSlider({
        gallery:true,
        item:1,
        loop:true,
        thumbItem:9,
        slideMargin:0,
        enableDrag: false,
        currentPagerPosition:'left',
	});
	

    $('#image-gallery').lightSlider({
        gallery:true,
        autoWidth: true,
        item:1,
        thumbItem:9,
        slideMargin: 0,
        speed:500,
        auto:true,
        loop:true,
        responsive: [],
        onSliderLoad: function() {
            $('#productViewer').removeClass('cS-hidden');
        }  
    }); */
	
});